// firebase.js
import { initializeApp } from "firebase/app";
import { 
  getAuth,
  setPersistence,
  browserLocalPersistence,
  signInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged,
  signOut
} from "firebase/auth";

const testing = false;
let API_URL = '';
if(testing){
  API_URL = 'http://localhost:3000';
} else {
  API_URL = 'https://aicloakerbackend-b665c292194b.herokuapp.com';
}

const firebaseConfig = {
  apiKey: "AIzaSyB_lEl_a2peHuegW1xV4jd5yvzhijZLmW0",
  authDomain: "ai-cloaker-93a44.firebaseapp.com",
  projectId: "ai-cloaker-93a44",
  storageBucket: "ai-cloaker-93a44.firebasestorage.app",
  messagingSenderId: "50047645201",
  appId: "1:50047645201:web:48886faac8dbc4a4b6e3b0",
  measurementId: "G-251SE9ETFB"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

/**
 * googleSignIn():
 *  1) Opens a Google sign-in popup (client side)
 *  2) Gets an ID token from result.user
 *  3) POST /googleSignIn { idToken } to your Express
 *  4) The server stores session info
 */
export async function googleSignIn() {
  try {
    const result = await signInWithPopup(auth, provider);

    // Get ID token from user
    const token = await result.user.getIdToken();
    // Send to backend
    const response = await fetch(`${API_URL}/googleSignIn`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ idToken: token })
    });
    if (!response.ok) {
      throw new Error(`Server returned ${response.status} on sign-in`);
    }
    const serverUser = await response.json();
    return serverUser;
  } catch (err) {
    console.error('Error signing in:', err);
    throw err; 
  }
}


/**
 * googleSignOut():
 *  1) POST /googleSignOut to clear session
 *  2) signOut(auth) on the client
 */
export async function googleSignOut() {
  try {
    // 1) Call backend to clear session
    const response = await fetch(`${API_URL}/googleSignOut`, {
      method: 'POST',
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error(`Server returned ${response.status} on sign-out`);
    }

    // 2) Also sign out from Firebase
    await signOut(auth);
    return true;
  } catch (err) {
    console.error('Error signing out:', err);
    return false;
  }
}

/**
 * watchAuthState(callback):
 *  We'll poll GET /isLoggedIn every 10s to see if there's a user session
 */
export function watchAuthState(callback) {
  const checkAuth = async () => {
    try {
      // Call your new route "GET /isLoggedIn"
      const response = await fetch(`${API_URL}/isLoggedIn`, {
        credentials: 'include'
      });
      if (response.ok) {
        const data = await response.json();
        callback(data.user || null);
      } else {
        callback(null);
      }
    } catch (error) {
      console.error('Auth check error:', error);
      callback(null);
    }
  };

  checkAuth();
  const intervalId = setInterval(checkAuth, 1000_000); // poll every 10s

  // If you want to stop polling, return a cleanup function
  return () => clearInterval(intervalId);
}
